<template>
  <div :class="['packaging-slide', { end, mobile }]">
    <div :class="['row', 'w-200', 'slide-wrapper', { showDescription }]">
      <div class="image-wrapper">
        <img class="packaging" :src="require('@/assets/images/wg-packaging.jpg')" alt="Wholly Guacamole Packaging">
      </div>
      <div class="image-wrapper shadow">
        <img class="title" :src="require('@/assets/images/text-high-pressure-tech.png')" alt="Wholly Guacamole Packaging">
      </div>
      <div class="copy-wrapper shadow">
        <p>It all comes down to hpt.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackagingSlide',
  props: {
    showDescription: Boolean,
    end: Boolean,
    mobile: Boolean,
  }
}
</script>

<style scoped lang="scss">
.packaging-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #779A30;
  color: white;
  transition: transform .5s ease-in;

  &.end {
    transform: translateY(-100%);
  }

  &.mobile {
    img {
      &.packaging {
        height: 100%;
      }
    }
  }
}

.row {
  position: relative;
  display: flex;
  height: 100%;
}

.w-200 {
  width: 200%;
}

.image-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 100%;
}

img {
  &.packaging {
    width: auto;
    height: 100%;
  }
  &.title  {
    width: 60%;
  }
}

.shadow {
  &.image-wrapper {
    filter: drop-shadow(0em 1em 0.2em #619570);
  }
  &.copy-wrapper {
    filter: drop-shadow(0em 0.5em 0.05em #599284);
  }
}

.slide-wrapper {
  transition: transform 0.5s ease-in;

  &.showDescription {
    transform: translateX(-50%);
  }
}

.copy-wrapper {
  position: absolute;
  top: 50%;
  left: 75%;
  width: 100vw;
  text-align: center;
  transform: translate(-50%, -17em);
}
</style>